$('.Rootline__Item--Expandable button').on('click', function () {
  $(this).parents('.Rootline__List').removeClass('Rootline__List--Collapsed');
});
